import { render, staticRenderFns } from "./SelectSuggestion.vue?vue&type=template&id=50480a9c&scoped=true&"
import script from "./SelectSuggestion.vue?vue&type=script&lang=js&"
export * from "./SelectSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50480a9c",
  null
  
)

export default component.exports